import { FieldValues, FormProvider, useForm } from 'react-hook-form'

interface IForm {
  children: string | JSX.Element | JSX.Element[]
  onSubmit: (data: FieldValues) => void
  defaultValues: FieldValues
}

const Form = ({ children, onSubmit, defaultValues }: IForm) => {
  const {
    clearErrors,
    control,
    formState,
    getFieldState,
    getValues,
    handleSubmit,
    register,
    reset,
    resetField,
    setError,
    setFocus,
    setValue,
    trigger,
    unregister,
    watch,
  } = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    defaultValues,
    shouldFocusError: true,
  })

  return (
    <FormProvider
      clearErrors={clearErrors}
      control={control}
      formState={formState}
      getFieldState={getFieldState}
      getValues={getValues}
      handleSubmit={handleSubmit}
      register={register}
      reset={reset}
      resetField={resetField}
      setError={setError}
      setFocus={setFocus}
      setValue={setValue}
      trigger={trigger}
      unregister={unregister}
      watch={watch}
    >
      <form
        style={{ display: 'flex', flexDirection: 'column' }}
        onSubmit={handleSubmit(onSubmit)}
      >
        {children}
      </form>
    </FormProvider>
  )
}

export default Form
